var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "footer" },
    [
      _c(
        "v-row",
        {
          staticClass: "footer__top-row",
          attrs: { variant: "flex", vertical: "center" }
        },
        [
          _c("v-column", { attrs: { large: 12 } }, [
            _c(
              "div",
              { staticClass: "footer__top" },
              [
                _c(
                  "router-link",
                  { attrs: { to: _vm.path("index") } },
                  [
                    _c("v-icon", {
                      staticClass: "footer__logo",
                      attrs: { name: "logo/footer-blue" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-button",
                  { attrs: { "on-click": _vm.scrollTop, variant: "fake" } },
                  [
                    _c("v-icon", {
                      staticClass: "footer__scroll-top",
                      attrs: { "data-hovered": "true", name: "ui/back-to-top" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        {
          staticClass: "footer__content",
          attrs: { variant: "flex", vertical: "start" }
        },
        [
          _c(
            "v-column",
            { attrs: { large: 6, tiny: 12 } },
            [
              _c("v-typo", {
                staticClass: "footer__title",
                attrs: { variant: "body-perex" },
                domProps: { innerHTML: _vm._s(_vm.$t("footer.orka.label")) }
              }),
              _vm._v(" "),
              _c(
                "v-row",
                { attrs: { variant: "flex", vertical: "start" } },
                _vm._l(_vm.orkaList, function(
                  listCollection,
                  listCollectionIndex
                ) {
                  return _c(
                    "v-column",
                    {
                      key: "footer__list-item-" + listCollectionIndex,
                      attrs: { large: 12, phone: 12 }
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "footer__list" },
                        _vm._l(listCollection, function(item, index) {
                          return _c(
                            "li",
                            {
                              key: "footer__list-item-" + index,
                              class: "logo-small logo-small--" + item
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "footer__list-card",
                                  attrs: { to: _vm.path(item) }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t("routes." + item + ".label")
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-column",
            { attrs: { large: 6, tiny: 12 } },
            [
              _c("v-typo", {
                staticClass: "footer__title",
                attrs: { variant: "body-perex" },
                domProps: { innerHTML: _vm._s(_vm.$t("footer.files.label")) }
              }),
              _vm._v(" "),
              _c(
                "v-row",
                { attrs: { variant: "flex", vertical: "start" } },
                [
                  _c("v-column", { attrs: { large: 12, phone: 12 } }, [
                    _c(
                      "ul",
                      { staticClass: "footer__files" },
                      _vm._l(_vm.filesList, function(item, index) {
                        return _c("li", { key: index }, [
                          _c(
                            "a",
                            {
                              staticClass: "footer__file-link",
                              attrs: {
                                href: _vm.getPdfPath + item.href,
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(item.label) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ]
                          )
                        ])
                      }),
                      0
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        {
          staticClass: "footer__social",
          attrs: { horizontal: "start", variant: "flex", vertical: "start" }
        },
        [
          _c(
            "v-column",
            { attrs: { large: 6, tablet: 12 } },
            [
              _c(
                "v-row",
                { attrs: { horizontal: "start", variant: "flex" } },
                [
                  _c("v-column", { attrs: { large: 6, tablet: 12 } }, [
                    _c(
                      "ul",
                      { staticClass: "footer__social-links" },
                      _vm._l(_vm.socialList, function(item, index) {
                        return _c("li", { key: index }, [
                          _c(
                            "a",
                            {
                              staticClass: "footer__social-link",
                              attrs: { href: item.href, target: "_blank" }
                            },
                            [_c("v-icon", { attrs: { name: item.icon } })],
                            1
                          )
                        ])
                      }),
                      0
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-column", { attrs: { large: 6, tablet: 12 } }, [
            _c("div", { staticClass: "footer__national" }, [
              _c(
                "div",
                { staticClass: "footer__national-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "footer__national-link",
                      attrs: {
                        to: {
                          query: {
                            modal: _vm.languageModalName
                          }
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { name: "ui/globe" } }),
                      _vm._v(" "),
                      _c("v-typo", {
                        staticClass: "footer__national-label",
                        attrs: { variant: "body-paragraph" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("common.national." + _vm.locale + ".lang")
                          )
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { attrs: { horizontal: "start", variant: "flex", vertical: "start" } },
        [
          _c(
            "v-column",
            { staticClass: "footer__bottom", attrs: { large: 12 } },
            [
              _c("v-typo", {
                staticClass: "footer__label",
                attrs: { variant: "body-paragraph" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("footer.bottom.credit", { year: _vm.currentYear })
                  )
                }
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "footer__created",
                  attrs: { href: "https://apploud.cz/", target: "_blank" }
                },
                [
                  _c("v-typo", {
                    staticClass: "footer__label",
                    attrs: { variant: "body-paragraph" },
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("footer.bottom.createdBy"))
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { attrs: { horizontal: "start", variant: "flex", vertical: "start" } },
        [
          _c(
            "v-column",
            { staticClass: "footer__bottom", attrs: { large: 12 } },
            [
              _c("v-typo", {
                staticClass: "footer__label",
                attrs: { variant: "body-paragraph" },
                domProps: { innerHTML: _vm._s(_vm.$t("footer.legal")) }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }